/**
 * @template K
 * @template T
 * @template {T[]} V
 * */
export class ArrayMap extends Map {

    /**
     * @param {[K, V][]} [entries]
     * */
    constructor(entries) {
        super(entries);
    }

    /**
     * @param {K} key
     * @param {T} value
     * */
    push(key, value) {
        if (!this.has(key)) {
            this.set(key, [value]);
        } else {
            this.get(key).push(value);
        }
        return this; // make it usable for Array.reduce
    }

    has(key) {
        return super.has(key) && this.get(key).length > 0;
    }
}

